import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TransactionView from './pages/TransactionView';
import FailedTransactions from './pages/FailedTransactions';
import CheckerInboxAmendment from './pages/CheckerInboxAmendment';
import PartnerBalance from './pages/PartnerBalance';
import CheckerInboxCancellation from './pages/CheckerInboxCancellation';
import CheckerInboxSettlement from './pages/CheckerInboxSettlement';
import MakerInbox from './pages/MakerInbox';
import Reports from './pages/Reports';
import PartnerWallet from './pages/PartnerWallet';
import PartnerOnboarding from './pages/PartnerOnboarding';
export function AppRouter({
  isLoggedIn,
  onLogout,
  onLogin
}) {
  return <>
      {isLoggedIn ? <Routes data-id="element-6">
          <Route path="/" element={<Dashboard onLogout={onLogout} data-id="element-8" />} data-id="element-7" />
          <Route path="/transactions" element={<TransactionView onLogout={onLogout} data-id="element-10" />} data-id="element-9" />
          <Route path="/failed-transactions" element={<FailedTransactions onLogout={onLogout} data-id="element-12" />} data-id="element-11" />
          <Route path="/checker-amendments" element={<CheckerInboxAmendment onLogout={onLogout} data-id="element-14" />} data-id="element-13" />
          <Route path="/checker-cancellations" element={<CheckerInboxCancellation onLogout={onLogout} data-id="element-16" />} data-id="element-15" />
          <Route path="/checker-settlements" element={<CheckerInboxSettlement onLogout={onLogout} data-id="element-18" />} data-id="element-17" />
          <Route path="/maker-inbox" element={<MakerInbox onLogout={onLogout} data-id="element-20" />} data-id="element-19" />
          <Route path="/reports" element={<Reports onLogout={onLogout} data-id="element-22" />} data-id="element-21" />
          <Route path="/partner-balance" element={<PartnerBalance onLogout={onLogout} data-id="element-24" />} data-id="element-23" />
          <Route path="/partner-wallet" element={<PartnerWallet onLogout={onLogout} data-id="element-26" />} data-id="element-25" />
          <Route path="*" element={<Navigate to="/" data-id="element-28" />} data-id="element-27" />
        </Routes> : <Routes data-id="element-29">
          <Route path="/login" element={<Login onLogin={onLogin} data-id="element-31" />} data-id="element-30" />
          <Route path="/onboarding" element={<PartnerOnboarding data-id="element-33" />} data-id="element-32" />
          <Route path="*" element={<Navigate to="/login" data-id="element-35" />} data-id="element-34" />
        </Routes>}
    </>;
}